import { render, staticRenderFns } from "./ModalEnvoiCommande.vue?vue&type=template&id=4e316532&"
import script from "./ModalEnvoiCommande.vue?vue&type=script&lang=js&"
export * from "./ModalEnvoiCommande.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports